import { Link } from "@trussworks/react-uswds";

function WebsiteLink({ url }: { url: string }) {
  const displayUrl = url.replace(/^https:\/\/(www.)?/, "").toLowerCase();
  return (
    <Link
      className="text-wrap body_font"
      style={{color:'#1E6692'}}
      variant="external"
      target="#"
      href={encodeURI(url)}
    >
      {displayUrl}
    </Link>
  );
}

export default WebsiteLink;
